window.addEventListener('load', () => {
    const buttons = document.querySelectorAll<HTMLLinkElement>(".FooterCtaComponent__buttons a");

    const check = (is_mobile: boolean) => {
        buttons.forEach((button) => {
            const href = button.getAttribute('href');
            const is_tel = href.startsWith('tel:');
            if (is_tel) {
                if (is_mobile) {
                    button.style.display = "flex";
                } else {
                    button.style.display = "none";
                }
            }
        });
    }

    const isMobile = () => {
        return window.matchMedia("(pointer: coarse)").matches &&
            window.matchMedia("(max-width: 768px)").matches;
    }

    check(isMobile());

    window.addEventListener('resize', () => {
        check(isMobile());
    });
});
